import pshLogo from '../../assets/psh-logo.png';
import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const links = [
    { nameKey: 'common.products', name: 'Products', path: '/products' },
    { nameKey: 'common.premium', name: 'Premium', path: '/products/premium' },
    { nameKey: 'common.exclusive', name: 'Exclusive', path: '/products/exclusive' },
    { nameKey: 'common.bundle', name: 'Bundles', path: '/products/bundle' },
    { nameKey: 'common.free_scripts', name: 'Free Scripts', path: '/products/free' },
    { nameKey: 'common.downloads', name: 'Downloads', path: '/downloads' },
    { nameKey: 'common.about', name: 'About', path: '/about' },
    { nameKey: 'common.contact', name: 'Contact', path: '/contact' },
    { nameKey: 'common.privacy', name: 'Privacy', path: '/privacy' },
    { nameKey: 'common.terms', name: 'Terms', path: '/terms' },
  ];



  return (
    <footer className="relative overflow-hidden bg-gray-50 text-gray-950 dark:bg-gray-950 dark:text-white">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gray-200/80 to-transparent dark:via-white/10" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-12 bg-gradient-to-b from-gray-100/60 to-transparent dark:from-white/[0.035]" />

      <div className="container relative mx-auto px-4 py-8">
        {/* Brand */}
        <div className="flex flex-col items-center gap-4 text-center">
          <Link to="/" className="flex items-center gap-3">
            <div className="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl overflow-hidden bg-slate-950 shadow-md ring-1 ring-black/10 dark:ring-white/15 group-hover:scale-105 transition-transform">
              <img src={pshLogo} alt="PSH Logo" className="h-full w-full object-cover" />
            </div>
            <div className="text-left">
              <span className="block text-lg font-black leading-none text-gray-950 notranslate dark:text-white" translate="no">PSH Store</span>
              <span className="mt-1 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-gray-500 dark:text-gray-400">
                <Sparkles className="h-3 w-3 text-amber-300" />
                Scripts hub
              </span>
            </div>
          </Link>

          <p className="max-w-xl text-sm leading-relaxed text-gray-600 dark:text-gray-400">
            {t('footer.description', 'Premium online scripts and tools. Simple, secure, and fast.')}
          </p>


        </div>

        {/* Links */}
        <div className="mt-8">
          <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
            {links.map((l) => (
              <Link
                key={l.name}
                to={l.path}
                className="rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-bold text-gray-600 shadow-sm transition-colors hover:border-gray-300 hover:bg-gray-950 hover:text-white dark:border-white/10 dark:bg-white/[0.045] dark:text-gray-300 dark:shadow-none dark:hover:bg-white dark:hover:text-gray-950"
              >
                {t(l.nameKey, l.name)}
              </Link>
            ))}
          </nav>
        </div>
      </div>

      {/* Bottom */}
      <div className="relative border-t border-gray-200/60 dark:border-white/10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col items-center justify-between gap-2 text-xs font-medium text-gray-500 dark:text-gray-400 sm:flex-row">
            <span className="notranslate" translate="no">&copy; {currentYear} PSH Store. {t('footer.rights_reserved', 'All rights reserved.')}</span>
            <span className="flex items-center gap-1">
              {t('footer.made_with', 'Made with')} <Heart className="w-4 h-4 text-red-500 fill-current mx-0.5" /> {t('footer.from', 'from')} <span className="notranslate ml-1" translate="no">PSH developers</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
